import axios from 'axios';
import moment from 'moment';
import * as types from './actionTypes';
import * as urls from './urlTypes';

export const updateDatahaulReports = updatedReport => ({
  type: types.UPDATE_DATAHAUL_REPORTS,
  updatedReport,
});

export const clearDataHaulPollingTimer = () => ({
  type: types.CLEAR_DATAHAUL_POLLING_TIMER,
});

export const poolingInProgress = status => ({
  type: types.DATAHAUL_POLLING_PROGRESS,
  status,
});

export function updateDatahaulReportsKafka({
  token,
  uid,
  accountId,
  weightType,
  divisor,
  title,
  products,
  colExpressionList,
  colHeaderList,
  reportFormat,
  baseList,
  baseHeaderList,
  selectedWeight,
  selectedWeightName,
}) {
  const url = `${urls.API_GATEWAY_URL}${urls.SOCKET_URL}/crosstab/${uid}/${accountId}`;
  return dispatch => {
    axios({
      url,
      method: 'post',
      withCredentials: true,
      headers: { Authorization: `Bearer ${token}` },
      responseType: 'json',
      data: {
        weightType,
        divisor,
        title,
        products,
        colExpressionList,
        colHeaderList,
        baseList,
        baseHeaderList,
        selectedWeightName,
      },
    })
      .then(response => {
        dispatch({
          type: types.UPDATE_DATAHAUL_REPORTS,
          payload: response.data.data,
          title,
          runDate: moment().format('MM/D/YYYY hh:mm A'),
          reportFormat,
          selectedWeight,
        });
      })
      .catch(response => console.warn(response));
  };
}
// Thunks - actions that return a function that accepts a dispatch
export function getDatahaulReports(uid, accountId) {
  const url = `${urls.ROOT_URL}/reports/datahaul/${uid}/${accountId}`;
  return dispatch => {
    axios({
      url,
      method: 'get',
      withCredentials: true,
      responseType: 'json',
    })
      .then(response =>
        dispatch({
          type: types.GET_DATAHAUL_REPORTS,
          payload: response.data.data,
        }),
      )
      .catch(response => console.warn(response));
  };
}

// Thunks - actions that return a function that accepts a dispatch
export function renameDatahaulReport(uid, accountId, reportID, title) {
  const url = `${urls.ROOT_URL}/reports/datahaul/rename/${uid}/${accountId}`;
  return dispatch => {
    axios({
      url,
      method: 'POST',
      withCredentials: true,
      responseType: 'json',
      data: {
        id: reportID,
        name: title,
      },
    })
      .then(() =>
        dispatch({
          type: types.RENAME_DATAHAUL_REPORT,
          reportID,
          title,
        }),
      )
      .catch(response => console.warn(response));
  };
}

// Thunks - actions that return a function that accepts a dispatch
export function deleteDatahaulReport(uid, accountId, reportID) {
  const url = `${
    urls.ROOT_URL
  }/reports/datahaul/${uid}/${accountId}/${reportID}`;
  return dispatch => {
    axios({
      url,
      method: 'DELETE',
      withCredentials: true,
      responseType: 'json',
    })
      .then(() =>
        dispatch({
          type: types.DELETE_DATAHAUL_REPORT,
          reportID,
        }),
      )
      .catch(response => console.warn(response));
  };
}
